<script setup lang="ts">
// PROPS
const { salesContact, variant } = defineProps({
    salesContact: { type: Object as PropType<SalesContact>, required: true },
    variant: { type: String as PropType<'whatsappOnly' | 'whatsappEmail'>, default: 'whatsappEmail' },
});

// EMITS
defineEmits<{
    openContactForm: [];
}>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { trackSalesContactPhoneLink } = useTracking();

// METHODS
const onPhoneClick = (): void => {
    trackSalesContactPhoneLink(salesContact.phone);
};
</script>

<template>
    <div class="space-y-6 rounded-xl bg-neutral-100 p-6">
        <div class="space-y-3">
            <div class="flex items-center gap-4">
                <div class="text-sm font-extrabold uppercase">{{ tt('salesContact.card.title') }}:</div>
                <div v-if="salesContact.supportedLanguages?.length" class="flex gap-2">
                    <UIcon v-for="language in salesContact.supportedLanguages" :key="language" class="text-lg" :name="`i-circle-flags-${language}`" />
                </div>
            </div>
            <div class="flex items-center gap-3">
                <UIcon name="lucide:circle-user" class="text-secondary-900 size-5 shrink-0" />
                <p>{{ salesContact.fullName }}</p>
            </div>
            <div class="flex items-end justify-between gap-3">
                <div class="flex items-center gap-3">
                    <UIcon name="lucide:phone" class="text-primary size-5" />
                    <BasePhoneLink class="text-primary" :phone="salesContact.phone" no-tracking @click="onPhoneClick" />
                </div>
                <div class="flex gap-3">
                    <SdpSalesContactWhatsappButton :sales-contact="salesContact" />
                    <SdpSalesContactContactFormButton
                        v-if="variant === 'whatsappEmail'"
                        :sales-contact="salesContact"
                        @click="$emit('openContactForm')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
